import { useState, useEffect } from 'react';
import useFetch from '../../../../components/hooks/useFetch';
import { IDCORREIOS_EXCLUIR_DEPENDENTE } from '../../../../services/meuCorreios';
import { getIPAddress } from '../../../../components/utils/GetIPAddress';
import { abreAlertaDialog } from '../../../../components/modal/AlertaDialog';

function FormExcluirDependente({
  acaoCancelar,
  acaoFechar,
  dependenteSelecionado,
  responsavel,
}) {
  const { request } = useFetch();
  const [ipAddress, setIpAddress] = useState('');
  useEffect(() => {
    const fetchIPAddress = async () => {
      const ip = await getIPAddress();
      const port = window.location.port;
      setIpAddress(ip + ':' + port);
    };
    fetchIPAddress();
  }, []);
  const cancelar = (ev) => {
    ev.preventDefault();
    acaoCancelar();
  };

  const excluir = async () => {
    const body = {
      motivo: 'Dependente',
      idCorreiosDependente: dependenteSelecionado.idCorreios,
      idCorreiosResponsavel: responsavel,
    };
    const { response } = await request(
      IDCORREIOS_EXCLUIR_DEPENDENTE(body, ipAddress),
    );

    if (response.ok) {
      abreAlertaDialog('Dependente excluido com sucesso!');
      acaoFechar();
    }
  };

  return (
    <>
      <div className="dialog-container">
        <div className="dialog-header">
          <h2>Excluir "{dependenteSelecionado?.nome}"</h2>
        </div>

        <div className="dialog-main" id="dialog-main-email">
          Tem certeza de que deseja excluir esse dependente?
        </div>

        <div className="dialog-footer">
          <button className="btn-txt btn-fecha-dialog" onClick={cancelar}>
            Cancelar
          </button>
          <button className="btn-pre" id="btn-excluir" onClick={excluir}>
            Excluir
          </button>
        </div>
      </div>
    </>
  );
}
export default FormExcluirDependente;
